// Lista oficial de Sectores y Subsectores Económicos
// Tomado del anexo "Sectores Subsectores Beneficiario" suministrado por iNNpulsa

export const SECTORES_ECONOMICOS = {
  "Agricultura, ganadería, caza, silvicultura y pesca": [
    "Agricultura, ganadería, caza y actividades de servicios conexas",
    "Silvicultura y extracción de madera",
    "Pesca y acuicultura"
  ],
  "Explotación de minas y canteras": [
    "Extracción de carbón de piedra y lignito",
    "Extracción de petróleo crudo y gas natural",
    "Extracción de minerales metalíferos",
    "Extracción de otras minas y canteras",
    "Actividades de servicios de apoyo para la explotación de minas y canteras"
  ],
  "Industrias manufactureras": [
    "Elaboración de productos alimenticios",
    "Elaboración de bebidas",
    "Elaboración de productos de tabaco",
    "Fabricación de productos textiles",
    "Confección de prendas de vestir",
    "Curtido y recurtido de cueros; fabricación de calzado; fabricación de artículos de viaje y guarnicionería",
    "Transformación de la madera y fabricación de productos de madera y de corcho"
  ],
  "Suministro de electricidad, gas, vapor y aire acondicionado": [
    "Suministro de electricidad, gas, vapor y aire acondicionado"
  ],
  "Distribución de agua; evacuación y tratamiento de aguas residuales, gestión de desechos y saneamiento ambiental": [
    "Captación, tratamiento y distribución de agua",
    "Evacuación y tratamiento de aguas residuales",
    "Recolección, tratamiento y disposición de desechos, recuperación de materiales",
    "Actividades de saneamiento ambiental y otros servicios de gestión de desechos"
  ],
  "Construcción": [
    "Construcción de edificios",
    "Obras de ingeniería civil",
    "Actividades especializadas para la construcción de edificios y obras de ingeniería civil"
  ],
  "Comercio al por mayor y al por menor; reparación de vehículos automotores y motocicletas": [
    "Comercio, mantenimiento y reparación de vehículos automotores y motocicletas, sus partes, piezas y accesorios",
    "Comercio al por mayor y en comisión o por contrata, excepto el comercio de vehículos automotores y motocicletas",
    "Comercio al por menor (incluso el comercio al por menor de combustibles), excepto el de vehículos automotores y motocicletas"
  ],
  "Transporte y almacenamiento": [
    "Transporte terrestre; transporte por tuberías",
    "Transporte acuático",
    "Transporte aéreo",
    "Almacenamiento y actividades complementarias al transporte",
    "Correo y servicios de mensajería"
  ],
  "Alojamiento y servicios de comida": [
    "Alojamiento",
    "Actividades de servicios de comidas y bebidas"
  ],
  "Información y comunicaciones": [
    "Actividades de edición",
    "Actividades cinematográficas, de video y producción de programas de televisión, grabación de sonido y edición de música",
    "Actividades de programación, transmisión y/o difusión",
    "Telecomunicaciones",
    "Desarrollo de sistemas informáticos (planificación, análisis, diseño, programación, pruebas), consultoría informática y actividades relacionadas",
    "Actividades de servicios de información"
  ],
  "Actividades financieras y de seguros": [
    "Actividades de servicios financieros, excepto las de seguros y de pensiones",
    "Seguros (incluso el reaseguro), seguros sociales y fondos de pensiones, excepto la seguridad social",
    "Actividades auxiliares de las actividades de servicios financieros"
  ],
  "Actividades inmobiliarias": [
    "Actividades inmobiliarias"
  ],
  "Actividades profesionales, científicas y técnicas": [
    "Actividades jurídicas y de contabilidad",
    "Actividades de administración empresarial; actividades de consultoría de gestión",
    "Actividades de arquitectura e ingeniería; ensayos y análisis técnicos",
    "Investigación científica y desarrollo",
    "Publicidad y estudios de mercado",
    "Otras actividades profesionales, científicas y técnicas"
  ],
  "Actividades de servicios administrativos y de apoyo": [
    "Actividades de alquiler y arrendamiento",
    "Actividades de empleo",
    "Actividades de las agencias de viajes, operadores turísticos, servicios de reserva y actividades relacionadas",
    "Actividades de seguridad e investigación privada",
    "Actividades de servicios a edificios y paisajismo (jardines, zonas verdes)",
    "Actividades administrativas y de apoyo de oficina y otras actividades de apoyo a las empresas"
  ],
  "Administración pública y defensa; planes de seguridad social de afiliación obligatoria": [
    "Administración pública y defensa; planes de seguridad social de afiliación obligatoria"
  ],
  "Educación": [
    "Educación"
  ],
  "Actividades de atención de la salud humana y de asistencia social": [
    "Actividades de atención de la salud humana",
    "Actividades de atención residencial medicalizada",
    "Actividades de asistencia social sin alojamiento"
  ],
  "Actividades artísticas, de entretenimiento y recreación": [
    "Actividades creativas, artísticas y de entretenimiento",
    "Actividades de bibliotecas, archivos, museos y otras actividades culturales",
    "Actividades de juegos de azar y apuestas",
    "Actividades deportivas y actividades recreativas y de esparcimiento"
  ],
  "Otras actividades de servicios": [
    "Actividades de asociaciones",
    "Mantenimiento y reparación de computadores, efectos personales y enseres domésticos",
    "Otras actividades de servicios personales",
    "Actividades veterinarias"
  ],
  "Actividades de los hogares individuales": [
    "Actividades de los hogares individuales como empleadores de personal doméstico",
    "Actividades no diferenciadas de los hogares individuales como productores de bienes y servicios para uso propio"
  ],
  "Actividades de organizaciones y entidades extraterritoriales": [
    "Actividades de organizaciones y entidades extraterritoriales"
  ]
};

export const SECTORES_LIST = Object.keys(SECTORES_ECONOMICOS);

export const VULNERABLE_POPULATION_TYPES = [
  { value: "victima_conflicto", label: "Víctima del conflicto armado" },
  { value: "reincorporada_farc", label: "Reincorporada FARC" },
  { value: "cabeza_hogar", label: "Cabeza de hogar" },
  { value: "indigena", label: "Indígena" },
  { value: "afrodescendiente", label: "Afrodescendiente" },
  { value: "adulto_mayor", label: "Adulto mayor" },
  { value: "mujer_rural", label: "Mujer rural" },
  { value: "otro", label: "Otro" }
];

/**
 * Calcula la edad en años a partir de la fecha de nacimiento (YYYY-MM-DD)
 */
export function calculateAge(birthDateStr) {
  if (!birthDateStr) return '';
  const birth = new Date(birthDateStr);
  if (isNaN(birth.getTime())) return '';
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--;
  }
  return age >= 0 && age < 150 ? age : '';
}
